export function diff(a, b) {
    return Object.fromEntries(Object.entries(b).filter(([key, val]) => key in a && a[key] !== val));
}
export function isObject(value) {
    return typeof value === 'object' && !Array.isArray(value) && value !== null;
}
//# sourceMappingURL=utils.js.map